<script lang="ts">
	import { checkVisibility } from '$lib/actions/checkVisibility';
	import Button from '$lib/buttons/v3/button.svelte';
	import ArrowRight from '$lib/icons/arrowRight.svelte';
	import Yotpo from '$lib/icons/yotpo.svelte';
	import { getYotpoPreview, type YotpoPreview } from '$lib/review/preview';
	import { onMount } from 'svelte';

	let preview = $state<YotpoPreview>();

	onMount(async () => {
		preview = await getYotpoPreview();
	});
</script>

<a class="block" href="/reviews" class:animate-pulse={!preview} class:h-[289px]={!preview}>
	<div class="flex flex-col rounded-2xl bg-[#0042E4] p-6 text-white lg:p-8 lg:pb-6">
		{#if preview}
			<p class="text-[16px]/[150%]">
				{preview.totalReviews} trusted reviews by <Yotpo
					class="ml-1 inline-block h-4 w-14 text-white"
				/>
			</p>
			<p class="mt-6 text-[32px]/[110%] tracking-[-.32px]">See all Reviews</p>
			<p class="mt-1 text-[64px]/[110%] tracking-[-.64px]">{preview.averageScore}/5</p>
			<div class="mt-6 flex justify-end">
				<Button href="/reviews" class="btn-white btn-large">
					<ArrowRight />
				</Button>
			</div>
		{/if}
	</div>
</a>
